module.exports = __webpack_public_path__ + "static/media/houseOfSeroBanner.8b39fb8f.png";